import React from "react";
import { StyleSheet, Text, Platform } from "react-native";

import moment from "moment";

import { MoodColors } from "../../common/mood/MoodsHelper";
import AppTheme from "../../AppTheme";

const TOO_OLD_HOURS = 24;

const IntegrationUpdatedTime = ({ time, connected, useLargeText = false }) => {
  const now = moment().tz("UTC");
  const updateTime = moment.utc(time);
  const when = time ? updateTime.fromNow() : ": Never";
  const duration = time ? now.diff(updateTime, "hours") : TOO_OLD_HOURS;

  // Lety: 08.26 Text should only turn red for connected integrations if it has been over 24 hours since last data collection (screenshot 05)
  const textStyle = {
    color:
      //!connected || duration >= TOO_OLD_HOURS ? MoodColors.VeryBad : AppTheme.DEFAULT_COLOR,
      duration >= TOO_OLD_HOURS ? MoodColors.VeryBad : AppTheme.DEFAULT_COLOR,
  };

  return (
    <Text style={[useLargeText ? styles.time : styles.timeSmall, textStyle]}>
      {!connected ? "Disconnected" : "Last updated " + when}
    </Text>
  );
};

export default IntegrationUpdatedTime;

const styles = StyleSheet.create({
  timeSmall: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  time: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
